export enum RiskAssessmentResultTestIds {
  Assessment = 'assessment',
  ControlType = 'controlType',
  Impact = 'impact',
  InternalAuditReport = 'internalAuditReport',
  Likelihood = 'likelihood',
  OversightAssessment = 'oversightAssessment',
  Rating = 'rating',
  Risk = 'risk',
  TestDate = 'resultDate',
}
